import { render, staticRenderFns } from "./TrustedBy.vue?vue&type=template&id=45fa9d09"
import script from "./TrustedBy.vue?vue&type=script&lang=js"
export * from "./TrustedBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports